/* ============================================================
   YUVENLIFE — Produkt-Detail-Popover („Mehr Infos")
   ------------------------------------------------------------
   Zentriertes Modal (Desktop) / Bottom-Sheet (Mobile, CSS).
   Öffnet über [data-popover-open][data-plan] oder Kartenklick.
   Inhalte: sofort Fallback aus PP_FALLBACK, dann lazy Upgrade
   via YuvenStorefront.fetchProductDetails (descriptionHtml +
   Metafelder custom.details / custom.abo_details — Wolfgang
   pflegt die im Shopify-Produkt-Editor). Ergebnis wird pro
   plan-key gecacht. CTA im Popover nutzt die bestehende
   data-add-to-cart-Delegation aus yuvenlife-cart.js.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.YUVENLIFE_SHOP;
  var SF  = window.YuvenStorefront;
  if (!CFG) return;

  /* ── Fallback-Inhalte pro plan-key (bis Wolfgang Shopify-Texte pflegt) ── */
  /* Fallbacks (Kurzfassungen aus Wolfgangs Produkttexten 2026-07-04) — greifen nur,
     wenn die Storefront-API nicht antwortet; sonst kommen die Shopify-Metafelder. */
  var PP_FALLBACK = {
    testen: {
      title: "Einzelflasche",
      meta: "500 ml · Einzelkauf · 30 Portionen",
      desc: "<h3>Das strukturierte, ölbasierte Nahrungsergänzungssystem für deine 30-Tage-Routine.</h3><p>Eine tägliche Öl-Routine mit ausgewählten Mikronährstoffen und Pflanzenstoffen in einer ölbasierten Trägermatrix — ohne Zyklen, ohne Reset-Prinzip, ohne ständiges Nachjustieren.</p><p><strong>1 Flasche = 30 Portionen</strong> · Tagesportion: ca. 2 Esslöffel / 16,7 ml pro Tag</p>",
      abo: null
    },
    routine30: {
      title: "Flexibles Abo",
      meta: "500 ml · monatlich · jederzeit anpassbar",
      desc: "<h3>Deine Functional Nutrition Oil Routine — automatisch jeden Monat.</h3><p>Du erhältst regelmäßig eine Flasche yuvenlife® — passend für ca. 30 Tage Anwendung.</p><ul><li>1 Flasche pro Monat · 30 Tagesportionen</li><li>79 € / Monat</li><li>Jede 6. Flasche gratis</li><li>keine Nachbestellung notwendig</li></ul>",
      abo: null
    },
    starter3: {
      title: "Startpaket",
      meta: "3 × 500 ml · einmalig · 90 Tagesportionen",
      desc: "<h3>Starterpaket: 3 Monate yuvenlife® Routine</h3><p>Für alle, die yuvenlife® nicht nur testen, sondern direkt über einen längeren Zeitraum in ihre tägliche Routine integrieren möchten.</p><ul><li>3 Flaschen = 90 Tagesportionen</li><li>Regulärer Einzelpreis: 237 €</li><li>Starterpaket: 219 € — Preisvorteil 18 €</li></ul>",
      abo: null
    }
  };

  var overlay = document.querySelector(".pp-overlay");
  var pop     = document.querySelector(".product-popover");
  if (!overlay || !pop) return;

  var els = {
    img:   pop.querySelector("[data-pp-img]"),
    title: pop.querySelector("[data-pp-title]"),
    meta:  pop.querySelector("[data-pp-meta]"),
    price: pop.querySelector("[data-pp-price]"),
    desc:  pop.querySelector("[data-pp-desc]"),
    abo:   pop.querySelector("[data-pp-abo]"),
    add:   pop.querySelector("[data-pp-add]"),
    close: pop.querySelector("[data-pp-close]")
  };

  var cache = {};        // plan-key → aufgelöste Details
  var lastTrigger = null;
  var currentPlan = null;

  function eur(n) {
    try { return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n); }
    catch (e) { return n + " €"; }
  }

  /* Shopify rich_text_field liefert JSON — minimaler Renderer → HTML */
  function richTextToHtml(value) {
    var doc; try { doc = JSON.parse(value); } catch (e) { return null; }
    function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
    function walk(node) {
      if (!node) return "";
      var kids = (node.children || []).map(walk).join("");
      switch (node.type) {
        case "root": return kids;
        case "paragraph": return "<p>" + kids + "</p>";
        case "heading": return "<h3>" + kids + "</h3>";
        case "list": return node.listType === "ordered" ? "<ol>" + kids + "</ol>" : "<ul>" + kids + "</ul>";
        case "list-item": return "<li>" + kids + "</li>";
        case "link": return '<a href="' + esc(node.url || "#") + '" target="_blank" rel="noopener">' + kids + "</a>";
        case "text":
          var t = esc(node.value || "");
          if (node.bold) t = "<strong>" + t + "</strong>";
          if (node.italic) t = "<em>" + t + "</em>";
          return t;
        default: return kids;
      }
    }
    var html = walk(doc);
    return html && html.trim() ? html : null;
  }

  /* Freisteller (transparentes PNG) statt Shopify-Studio-Shots — 500ml-Flasche
     für alle Karten, bis Henning 100ml-/3er-Freisteller liefert. */
  /* Modal nutzt immer die Card-Bilder (André) — keine Freisteller */
  var PP_IMG = document.querySelector('[data-ap-page]') ? {
    testen:    { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popup-single-white-bg_4b704190-571a-49ae-aafc-5c3e17821fa4.png?v=1786692887", alt: "yuvenlife Einzelflasche 500 ml" },
    routine30: { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popup-abo-white-bg.png?v=1786692896", alt: "yuvenlife Flexibles Abo" },
    starter3:  { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popup-starter-white-bg.png?v=1786692905", alt: "yuvenlife Startpaket 3 × 500 ml" },
    travel:    { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popup-travel-white-bg.png?v=1786692913", alt: "yuvenlife 100 ml" }
  } : {
    testen:    { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popover-einzelflasche-neues-label.webp?v=1786975456", alt: "yuvenlife Einzelflasche 500 ml" },
    routine30: { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popover-abo-neues-label.webp?v=1786975473", alt: "yuvenlife Flexibles Abo" },
    starter3:  { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popover-starterpaket-neues-label.webp?v=1786975464", alt: "yuvenlife Startpaket 3 × 500 ml" },
    travel:    { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-popover-travel-size-neues-label.webp?v=1786975480", alt: "yuvenlife 100 ml" },
    paket6:    { src: "https://cdn.shopify.com/s/files/1/0885/9186/0041/files/yuvenlife-6er-original-tight.png?v=1786980395", alt: "yuvenlife 5+1 Paket" }
  };
  function cardImageFor(plan) { return PP_IMG[plan] || null; }

  function render(plan, d) {
    els.title.textContent = d.title || "";
    els.meta.textContent = d.meta || "";
    els.price.innerHTML = d.priceHtml || "";
    els.desc.innerHTML = d.desc || "";
    if (d.abo) { els.abo.innerHTML = d.abo; els.abo.removeAttribute("hidden"); }
    else { els.abo.innerHTML = ""; els.abo.setAttribute("hidden", ""); }
    if (d.img) { els.img.src = d.img.src; els.img.alt = d.img.alt || d.title || ""; }
    els.add.setAttribute("data-plan", plan);
    els.add.disabled = d.available === false;
    els.add.textContent = d.available === false ? "Vorübergehend ausverkauft" : "In den Warenkorb";
  }

  function baseData(plan) {
    var fb = PP_FALLBACK[plan] || {};
    var cfgFb = (CFG.fallback && CFG.fallback[plan]) || {};
    var isSub = CFG.map && CFG.map[plan] && CFG.map[plan].type === "subscription";
    var price = cfgFb.price != null ? eur(cfgFb.price) : "";
    return {
      title: fb.title || cfgFb.title || "",
      meta: fb.meta || cfgFb.meta || "",
      priceHtml: price ? ('<b>' + price + '</b>' + (isSub ? "<small> / Monat</small>" : "")) : "",
      desc: fb.desc || "",
      abo: fb.abo || null,
      img: cardImageFor(plan),
      available: true
    };
  }

  function hydrate(plan) {
    if (cache[plan] || !SF || !SF.fetchProductDetails) return;
    var m = CFG.map && CFG.map[plan];
    if (!m || !m.variantGid) return;
    SF.fetchProductDetails([m.variantGid]).then(function (r) {
      if (!r.ok || !r.nodes.length || !r.nodes[0]) return;
      var v = r.nodes[0], p = v.product || {};
      var d = baseData(plan);
      var detailsHtml = p.details && richTextToHtml(p.details.value);
      var aboHtml = p.aboDetails && richTextToHtml(p.aboDetails.value);
      var isSubPlan = m.type === "subscription";
      if (isSubPlan && aboHtml) {
        /* Abo-Text (custom.abo_details) ist self-contained → als Haupttext, kein Doppel-Block */
        d.desc = aboHtml; d.abo = null;
      } else {
        if (detailsHtml) d.desc = detailsHtml;
        else if (p.descriptionHtml && p.descriptionHtml.trim()) d.desc = p.descriptionHtml;
        if (aboHtml) d.abo = aboHtml;
      }
      if (CFG.flags && CFG.flags.livePrices && v.price && v.price.amount) {
        var isSub = m.type === "subscription";
        d.priceHtml = "<b>" + eur(parseFloat(v.price.amount)) + "</b>" + (isSub ? "<small> / Monat</small>" : "");
      }
      /* featuredImage bewusst NICHT übernehmen — lokale Freisteller bleiben (Studio-Shots clippen im Modal) */
      d.available = v.availableForSale !== false;
      cache[plan] = d;
      if (currentPlan === plan) render(plan, d);
    });
  }

  function open(plan, trigger) {
    currentPlan = plan;
    lastTrigger = trigger || null;
    render(plan, cache[plan] || baseData(plan));
    hydrate(plan);
    overlay.removeAttribute("hidden");
    pop.setAttribute("aria-hidden", "false");
    document.documentElement.setAttribute("data-pp-open", "true");
    els.close.focus();
  }

  function close() {
    currentPlan = null;
    pop.setAttribute("aria-hidden", "true");
    overlay.setAttribute("hidden", "");
    document.documentElement.removeAttribute("data-pp-open");
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    lastTrigger = null;
  }

  /* ── Events ── */
  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-popover-open]");
    if (openBtn) { e.preventDefault(); open(openBtn.getAttribute("data-plan"), openBtn); return; }
    if (e.target.closest("[data-pp-close]")) { close(); return; }
    /* Kartenklick (außerhalb von Links/Buttons) → Popover statt Direkt-Add */
    var card = e.target.closest(".option-card");
    if (card && !e.target.closest("a,button")) {
      var b = card.querySelector("[data-add-to-cart]");
      if (b) open(b.getAttribute("data-plan"), card);
    }
  });

  /* CTA im Popover: data-add-to-cart-Delegation (cart.js) fügt hinzu + öffnet Drawer — wir schließen nur das Popover */
  els.add.addEventListener("click", function () { setTimeout(close, 0); });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || pop.getAttribute("aria-hidden") !== "false") return;
    close();
  });

  /* Fokus-Falle im offenen Dialog */
  pop.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var f = pop.querySelectorAll("button:not([disabled]), a[href]");
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.YuvenPopover = { open: open, close: close };
})();
